import url from '../url'
import headers from '../headers'
import moment from 'moment'

export default {
	getAll (context, user_uid, watch_id, type_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/?size=${size}`,
			headers.bearer()
		)
	},
	getAllByInterval (context, user_uid, watch_id, type_id, date_start, date_end) {
		date_start = encodeURIComponent(moment(date_start).format())
		date_end = encodeURIComponent(moment(date_end).format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/interval/?start=${date_start}&end=${date_end}`,
			headers.bearer()
		)
	},
	getAllResume (context, user_uid, watch_id, type_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/resume/?size=${size}`,
			headers.bearer()
		)
	},
	getAllResumeByInterval (context, user_uid, watch_id, type_id, date_start, date_end) {
		date_start = encodeURIComponent(moment(date_start).format())
		date_end = encodeURIComponent(moment(date_end).format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/resume/interval/?start=${date_start}&end=${date_end}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, type_id, alert_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/`, 
			headers.bearer()
		)
	},
	getResume (context, user_uid, watch_id, type_id, alert_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/resume/`,
			headers.bearer()
		)
	},
	getReadings (context, user_uid, watch_id, type_id, alert_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/readings/`,
			headers.bearer()
		)
	},
	getWarnings (context, user_uid, watch_id, type_id, alert_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/warnings/`,
			headers.bearer()
		)
	},
	getReports (context, user_uid, watch_id, type_id, alert_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/reports/`,
			headers.bearer()
		)
	},
	addReport (context, user_uid, watch_id, type_id, alert_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${alert_id}/reports/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, type_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/readingtypes/${type_id}/alerts/${model.id}`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/alerts.js